var map = {
	"./envelope01.png": "2IDq",
	"./envelope01en.png": "1T5B",
	"./envelope01khm.png": "QMlf",
	"./envelope01thai.png": "NevM",
	"./envelope01vi.png": "PDry",
	"./envelope01zh-tw.png": "YdtT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dy0l";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img ^\.\/envelope01.*\.png$
// module id = dy0l
// module chunks = 1